import React from 'react';
import { css } from '@emotion/react';
import { useSelector } from 'react-redux';

import t from 'react-translate';
import { Course } from 'redux/schemas/models/course';
import { black } from 'styles/global_defaults/colors';
import { openSans } from 'styles/global_defaults/fonts';
import { getCurrentInstitution } from 'redux/selectors/institutions';
import EntitlementBadge from 'offerings/components/entitlement-badge';

type Props = {
  journey: Course,
  className?: string,
};

const OfferedToSection = (props: Props) => {
  const { journey, className } = props;
  const currentInstitution = useSelector(getCurrentInstitution);
  const metadataList = journey.courseMetadata?.map(({ metadataFieldId, metadataValueId }) => ({
    field: currentInstitution?.metadataFields?.find(field => field.id === metadataFieldId)?.name,
    value: currentInstitution?.metadataFields?.find(field => field.id === metadataFieldId)?.metadataValues?.find(value => value.id === metadataValueId)?.value,
  }));
  const styles = css`
    text-align: center;

    .header {
      color: ${black};
      font-size: 12px;
      font-weight: 600;
      line-height: 15px;
      font-family: ${openSans}px;
    }

    .entitlement-values {
      line-height: 35px;

      & > * {
        vertical-align: bottom;
      }
    }
  `;

  const entitlementsToRender = journey.entitlements.filter(
    (entitlement) => {
      const currentProfileSetting = currentInstitution.profileSettings.orgLevel.find(
        (profileSetting) => profileSetting.id === entitlement.profileSettingId,
      );

      if (currentProfileSetting) {
        return !currentProfileSetting.isHidden;
      }

      return false;
    },
  );

  const hasEntitlements = !!entitlementsToRender.length;

  if (hasEntitlements || metadataList?.length) {
    return (
      <div css={styles} className={className}>
        <div className='entitlement-values'>
          {hasEntitlements && entitlementsToRender.reduce(
            (acc, curr) => acc.concat(curr.values.map((value, index) => ({
              value: `${curr.profileSettingName}: ${value}`,
              key: `${curr.id}-${index}-${value}`,
            }))),
            [],
          ).map((entitlementBadge) => (
            <EntitlementBadge
              key={entitlementBadge.key}
              value={entitlementBadge.value}
              className='font-weight-bolder'
            />
          ))}
          {metadataList?.map(({ field, value }) => (
            <EntitlementBadge
              key={field}
              value={`${field}: ${value}`}
              icon='skill-tag'
              className='font-weight-bolder'
            />
          ))}
        </div>
      </div>
    );
  }

  return null;
};

export default OfferedToSection;
